import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class StaffLicensesTab extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      staff_id: this.props.staff_id,
      name: null,
      type: null,
      only_active: 1,
      expiration: '',
      dispatch: '',
      staff_licenses: [],
      license_names: [
        {value: "AVI", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesNome.AVI},
        {value: "CEL", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesNome.CEL},
        {value: "GMP", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesNome.GMP},
      ],
      license_types: [
        {value: "", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesTipo.SelecionarTipo},
        {value: "CHT", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesTipo.CHT},
        {value: "CCT", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesTipo.CCT},
      ]
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.updateLicenses = this.updateLicenses.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.addToRevision = this.addToRevision.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
  }
  
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_licenses)) {
      this.setState({
        staff_licenses: newProps.staff_licenses,
        loaded: 1
      });
    }
  }

  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   var self = this;
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     name: this.state.name,
  //     type: this.state.type,
  //     expiration: this.state.expiration,
  //     dispatch: this.state.dispatch,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/habilitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.setState({ staff_licenses: responseJson.data });
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }

  // // Fetch salvando a edição
  // addToRevision(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de associar essa habilitação a uma revisão de designação aberta?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/revisao/habilitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch ativando um item
  // ativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa habilitação?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/habilitacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_licenses: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch deletando um item
  // desativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa habilitação?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/habilitacao/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_licenses: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/habilitacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_licenses: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/habilitacoes/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_licenses: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }

  // updateLicenses(event) {
  //   var id = event;
  //   var confirm = window.confirm('Tem certeza que gostaria de atualizar habilitações desse colaborador?');
  //   if (confirm) {
  //     var datasave = {
  //       only_active: this.state.only_active,
  //       staff_id: id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/atualizar/habilitacoes', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_licenses: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tituloHabilitacoes}</h3>
  <hr/>
  {(this.state.staff_licenses === null || typeof this.state.staff_licenses === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.nenhumaHabilitacaoCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Tipo}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Nome}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Expedicao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Vencimento}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Valido}?</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Status}</th>
          {/* <th className="col-md-1 text-center">Ações</th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_licenses).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_licenses[k].type}</td>
              <td className="text-center">{self.state.staff_licenses[k].name}</td>
              <td className="text-center">{self.state.staff_licenses[k].dispatch_str}</td>
              <td className="text-center">{self.state.staff_licenses[k].expiration_str}</td>
              <td className="text-center">{self.state.staff_licenses[k].expire_status_str}</td>
              <td className="text-center">{(self.state.staff_licenses[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Arquivado}</span>}</td>
              {/* <td className="text-center">
                {(self.state.staff_licenses[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_licenses[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_licenses[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-sm btn-primary" value={self.state.staff_licenses[k].id} onClick={self.addToRevision}><i className="fa fa-fw fa-plus"></i></button>
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Adicionar habilitação</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Tipo:</label>
        <Select
          className="form-field-name"
          name="type"
          value={this.state.type}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'type')}
          options={this.state.license_types}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Nome:</label>
        <Select
          className="form-field-name"
          name="name"
          value={this.state.name}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'name')}
          options={this.state.license_names}
        />    
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data de expedição:</label>
        <InputMask value={this.state.dispatch}  maskChar={null} name="dispatch" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'dispatch')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Vencimento:</label>
        <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar habilitação</button>
  </form> */}
</div>
    );
  }
}

export default StaffLicensesTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffLicensesTab.js